import * as React from "react"
import { cn } from "@/lib/utils"
const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        /* Campo del sistema del 29-10: 44 sul computer, 52 sul telefono (dove il testo sta a 16 px, regola in
           index.css). Sola lettura e non disponibile: fondo surface-3, bordo line, testo ink-2. */
        "flex h-11 w-full rounded-md border border-line-input bg-surface px-3 py-1 text-body text-ink transition-colors duration-150 ease-enter file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-ink placeholder:text-ink-3 focus-visible:outline-none focus-visible:border-brand focus-visible:ring-1 focus-visible:ring-brand disabled:cursor-not-allowed disabled:border-line disabled:bg-surface-3 disabled:text-ink-2 [&[readonly]]:border-line [&[readonly]]:bg-surface-3 [&[readonly]]:text-ink-2 aria-[invalid=true]:border-danger max-md:h-[52px]",
        /* `focus-within` oltre a `focus-visible`, e non e' ridondanza. Su
           `<input type="date">` la tabulazione attraversa i pezzi interni
           (giorno, mese, anno) e poi il bottoncino del calendario, che stanno
           nello shadow DOM: a quel passo il campo NON corrisponde piu' a
           `:focus`, l'anello sparisce, e l'unica cosa che segna dove sei resta
           l'alone di sistema sull'icona da 16 px. Misurato a mano sul campo
           «Valido fino al»: tappa 29 e 30 anello, tappa 31 niente.
           `:focus-within` invece regge finche' il fuoco e' dentro il campo. */
        "focus-within:border-brand focus-within:ring-1 focus-within:ring-brand",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"
export { Input }
